import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const Protected = ({ children }) => {
  const {isAuthenticated, user} = useSelector((state) => state.auth);
  const { pathname } = useLocation();
  let portal = pathname.split("/")[1];
  //console.log(portal);
  const role = user.userrole;
  //console.log(role);
  const isValid =
    role === undefined || role === null
      ? false
      : role.toLowerCase().indexOf("admin") !== -1 && portal.toLowerCase() === "admin"
      ? true
      : role.toLowerCase() === "requestor" && portal.toLowerCase() === "customer"
      ? true
      : role.toLowerCase() === "investigator" && portal.toLowerCase() === "investigator"
      ? true
      : role.toLowerCase() === "qa" && portal.toLowerCase() === "qa"
      ? true
      : false;
  if (!isValid || !isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
};
export default Protected;
